import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Flex, Select, TextField } from '@radix-ui/themes';
import { FormField } from 'shared/components';
import { SalaryGroupViewModel } from './salary-group.view-model';
import { useTranslation } from 'react-i18next';

function SalaryGroupView({ viewModel }: { viewModel: SalaryGroupViewModel }) {
   const { t } = useTranslation('global');
   return (
      <Flex className="salary-group" gap="3">
         <FormField
            label="Зарплата від"
            error={viewModel.jobManager.form.controls['salary_min'].error}
         >
            <TextField.Root
               size="3"
               color="blue"
               placeholder="Число"
               value={viewModel.jobManager.form.controls['salary_min'].value}
               onChange={(e) => {
                  viewModel.jobManager.form.controls['salary_min'].setValue(e.target.value);
               }}
            ></TextField.Root>
         </FormField>

         <FormField
            label="Зарплата до"
            error={viewModel.jobManager.form.controls['salary_max'].error}
         >
            <TextField.Root
               size="3"
               color="blue"
               placeholder="Число"
               value={viewModel.jobManager.form.controls['salary_max'].value}
               onChange={(e) => {
                  viewModel.jobManager.form.controls['salary_max'].setValue(e.target.value);
               }}
            ></TextField.Root>
         </FormField>

         <FormField
            label="Вибрати валюту"
            required={viewModel.currencyRequired}
            error={viewModel.jobManager.form.error['salary_currency']}
         >
            <Select.Root
               size="3"
               value={viewModel.jobManager.form.controls['salary_currency'].value}
               onValueChange={(value) => {
                  viewModel.jobManager.form.controls['salary_currency'].setValue(value);
               }}
            >
               <Select.Trigger placeholder="Валюта"></Select.Trigger>
               <Select.Content
                  color="blue"
                  position="popper"
                  onCloseAutoFocus={(e) => e.preventDefault()}
               >
                  <Box maxHeight="250px">
                     {viewModel.currencies.map((curr) => (
                        <Select.Item key={curr.value} value={curr.value}>
                           {curr.viewValue}
                        </Select.Item>
                     ))}
                  </Box>
               </Select.Content>
            </Select.Root>
         </FormField>
      </Flex>
   );
}

export const SalaryGroup = observer(SalaryGroupView);
